import { Menu, X } from "lucide-react";
import { useEffect, useState } from "react";

export const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState("beranda");

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);

      const sections = ["beranda", "tentang", "produk", "keunggulan", "kontak"];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetBottom = offsetTop + element.offsetHeight;

          if (scrollPosition >= offsetTop && scrollPosition < offsetBottom) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = ["Beranda", "Tentang", "produk", "keunggulan", "Kontak"];

  const handleClick = (e, link) => {
    e.preventDefault();
    const element = document.getElementById(link.toLowerCase());
    if (element) {
      const offsetTop = element.offsetTop - 64;
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      });
    }
    setIsOpen(false);
  };

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-lg" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div
            className="flex items-center cursor-pointer"
            onClick={(e) => handleClick(e, "Beranda")}
          >
            <img
              src={scrolled ? "/logo.png" : "/logo2.png"}
              alt="Logo"
              className={`h-10 w-10 transition-all ${
                scrolled ? "opacity-100" : "opacity-90"
              }`}
            />
            <span
              className={`ml-2 text-xl font-bold ${
                scrolled ? "text-gray-900" : "text-white"
              }`}
            >
              Rajutan Sari Asa
            </span>
          </div>

          <div className="hidden md:flex space-x-8">
            {navLinks.map((link) => {
              const isActive = activeSection === link.toLowerCase();
              return (
                <a
                  key={link}
                  href={`#${link.toLowerCase()}`}
                  onClick={(e) => handleClick(e, link)}
                  className={`relative hover:text-pink-600 transition-all duration-300 font-medium ${
                    scrolled ? "text-gray-700" : "text-white"
                  } ${isActive ? "text-pink-600" : ""}`}
                >
                  {link}
                  {isActive && (
                    <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-pink-600 animate-[slideIn_0.3s_ease-out]"></span>
                  )}
                </a>
              );
            })}
          </div>

          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden">
            {isOpen ? (
              <X className={scrolled ? "text-gray-900" : "text-white"} />
            ) : (
              <Menu className={scrolled ? "text-gray-900" : "text-white"} />
            )}
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden bg-white shadow-lg animate-[slideDown_0.3s_ease-out]">
          {navLinks.map((link) => {
            const isActive = activeSection === link.toLowerCase();
            return (
              <a
                key={link}
                href={`#${link.toLowerCase()}`}
                onClick={(e) => handleClick(e, link)}
                className={`block px-4 py-3 transition-colors ${
                  isActive
                    ? "bg-pink-50 text-pink-600 font-semibold border-l-4 border-pink-600"
                    : "text-gray-700 hover:bg-pink-50 hover:text-pink-600"
                }`}
              >
                {link}
              </a>
            );
          })}
        </div>
      )}
    </nav>
  );
};
